import { API } from '../../util/helper';

export const getPepsicoBaselineData = (payload) => {
  return API.post(`${process.env.REACT_APP_BACKEND_BASE_URL}dashboards/supermarket/getPepsicoBaseline`, payload);
};
